import {ColInfo, utils, WorkBook, WorkSheet, writeFile} from 'xlsx';

/**
 * ExcelHelperUtil provides Excel creation and export logic for 'excel-export.worker.ts'.
 * This code is separated from the Worker for testing purposes.
 */
export class ExcelHelperUtil {
  /**
   *  - Creates an Excel WorkSheet from an array of objects (with no nested properties)
   *  - All columns are given a standard width
   *
   * @param data an array of objects with no nested properties
   */
  public static createWorkSheetFromObjects(data: any[]): WorkSheet {
    const workSheet: WorkSheet = utils.json_to_sheet(data);
    //Set all columns to be the same width
    const columnSettings: ColInfo[] = [];
    Object.keys(data[0]).forEach(() => columnSettings.push({width: 25}));
    workSheet['!cols'] = columnSettings;
    return workSheet;
  }

  /**
   *  - Creates an Excel WorkSheet from array of array with pre-defined headers
   *  - All columns are given a standard width
   *
   * @param data an arrays of array  with pre-defined header
   */
  public static createWorkSheetFromArrays(data: any[][]): WorkSheet {
    const workSheet: WorkSheet = utils.aoa_to_sheet(data);

    //Set all columns to be the same width
    const columnSettings: ColInfo[] = [];
    data[0].forEach(() => columnSettings.push({width: 25}));
    workSheet['!cols'] = columnSettings;
    return workSheet;

  }

  /**
   * Exports an Excel WorkBook based on the provided sheets, sheetNames and fileName
   *
   * @param sheets Array of WorkSheets to be added to the WorkBook
   * @param sheetNames Name of WorkSheets in the desired order
   * @param fileName The name of the exported Excel file
   */
  public static exportWorkBookFromSheets(sheets: WorkSheet[], sheetNames: string[], fileName: string) {
    const workBook: WorkBook = utils.book_new();
    for (const [i, workSheet] of sheets.entries()) {
      utils.book_append_sheet(workBook, workSheet, sheetNames[i]);
    }

    writeFile(workBook, fileName);
  }

  public static createWorkBookFromSheets(sheets: WorkSheet[], sheetNames: string[]): WorkBook {
    const workBook: WorkBook = utils.book_new();
    for (const [i, workSheet] of sheets.entries()) {
      utils.book_append_sheet(workBook, workSheet, sheetNames[i]);
    }
    return workBook;
  }

  public static writeFile(workBook: WorkBook, fileName: string) {
    writeFile(workBook, fileName);
  }
}
